import * as React from 'react';
import { classes } from './Badge.st.css';
import { BadgeDefaultProps, BadgeProps, BadgePriority } from './types';
import { BadgeBase } from './Badge.base';
import classnames from 'classnames';

export class Badge extends React.Component<BadgeProps> {
  static displayName = 'Badge';
  static defaultProps: BadgeDefaultProps = { priority: BadgePriority.default };

  render() {
    const { className, priority, ...rest } = this.props;
    return (
      <BadgeBase
        className={classnames(
          classes.root,
          classes[`priority-${priority}`],
          className,
        )}
        data-priority={priority}
        {...rest}
      />
    );
  }
}
